export const users = {
  all_users: "accounts/user/",
  get_one_user: (id: number) => `accounts/user/get-by/?id=${id}`,
  delete_user: (id: number) => `accounts/user/?id=${id}`,
  statistics: "accounts/user/statistics/",
  update_user_role: "accounts/user/role/",
};
